'use client';

import { cn } from '@/lib/utils';
import { useQueryClient } from '@tanstack/react-query';
import { LogOut } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';
import { ConfirmationModalCompact } from './ui/extended/confirm-modal-compact';
export default function LogoutButton({
  serverLogout,
  className,
  showText = true
}: {
  serverLogout: () => void;
  className?: string;
  showText?: boolean;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const querClient = useQueryClient();
  const handleLogoutConfirm = () => {
    querClient.clear();
    serverLogout();
    setIsModalOpen(false);
  };
  const handleLogoutClick = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  return <>
      <Button variant="ghost" className={cn(`h-[50px] w-full justify-start rounded-none px-1 text-red-500 hover:bg-transparent hover:text-red-500`, className)} onClick={handleLogoutClick} data-sentry-element="Button" data-sentry-source-file="logout-button.tsx">
        <LogOut className="mr-2 size-4" data-sentry-element="LogOut" data-sentry-source-file="logout-button.tsx" />
        {showText && 'Log out'}
      </Button>
      <ConfirmationModalCompact isOpen={isModalOpen} onClose={handleModalClose} onConfirm={handleLogoutConfirm} data-sentry-element="ConfirmationModalCompact" data-sentry-source-file="logout-button.tsx" />
    </>;
}